module.exports = __webpack_public_path__ + "static/media/simonCocking .1be61e2c.png";